const useAuthTypes = () => {
    return {
        LOGIN: "[Auth] => Login",
        GET_COUNTRIES: "[Auth] => Get Countries"
    };
}

export default useAuthTypes;